
import React from "react";
import { LucideProps } from "lucide-react";

// Custom Extension icon component that follows the lucide-react pattern
export const Extension = React.forwardRef<SVGSVGElement, LucideProps>(
  ({ color = "currentColor", size = 24, strokeWidth = 2, ...props }, ref) => (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M9.5 4v2.5a2.5 2.5 0 0 1-2.5 2.5H4.5a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2H7a2.5 2.5 0 0 1 2.5 2.5V20a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-2.5a2.5 2.5 0 0 1 2.5-2.5h2.5a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2h-2.5a2.5 2.5 0 0 1-2.5-2.5V4a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2z" />
    </svg>
  )
);

Extension.displayName = "Extension";

export default Extension;
